import { configureStore } from '@reduxjs/toolkit';
import workspaceReducer from './slices/workspaceSlice';
import orchestrationReducer from './slices/orchestrationSlice';
import dashboardReducer from './slices/dashboardSlice';
import testLogsReducer from './slices/testLogsSlice';
import rolesReducer from './slices/rolesSlice';
import workflowPipelineReducer from './slices/workflowPipelineSlice';
import testCasesReducer from './slices/testCasesSlice';
import workflowConversationReducer from './slices/workflowConversationSlice';
import advancedOrchestrationReducer from './slices/advancedOrchestrationSlice';
import apiDocumentationReducer from './slices/documentationSlice';
// Import metaData reducer from legacy store for authorization persistence
import metaDataReducer from './slices/metaDataSlice';
import variablesReducer from './slices/variablesSlice';

/**
 * The full reducer map, exported so tests can build a store that stays in step
 * with this one. Component tests that hand-pick a few reducers break whenever a
 * new slice is added — a selector reads its missing slice and throws while
 * rendering, far from the behaviour under test. Build test stores from this map
 * and supply only the `preloadedState` a test actually cares about.
 */
export const rootReducerMap = {
  workspace: workspaceReducer,
  orchestration: orchestrationReducer,
  dashboard: dashboardReducer,
  testLogs: testLogsReducer,
  roles: rolesReducer,
  workflowPipeline: workflowPipelineReducer,
  testCases: testCasesReducer,
  workflowConversation: workflowConversationReducer,
  advancedOrchestration: advancedOrchestrationReducer,
  apiDocumentation: apiDocumentationReducer,
  metaData: metaDataReducer,
  variables: variablesReducer,
};

/**
 * Redux store for src/ application
 * Now includes metaData and variables reducers from legacy store
 * for authorization and variable persistence
 */
export const store = configureStore({
  reducer: rootReducerMap,
  devTools: import.meta.env.DEV,
});

export default store;
